import httpClient from "../utils/httpClient";

export const GetJewelleryParameter = async (payload) => {
    const response = await httpClient.post('/StyleJewellery/GetJewelleryParameter', payload);
    return response.data;
};

export const GetParameters = async (payload) => {
    const response = await httpClient.post('/api/Parameter/GetParameters', {});
    return response.data;
};

export const GetCategoryWiseSubCategory = async (payload) => {
    const response = await httpClient.post('/api/Parameter/GetCategoryWiseSubCategory', payload);
    return response.data;
};